




import {Component, Prop, Watch} from "vue-property-decorator";
	import Chart from "@/libs/clients/components/Clt/Chart.vue";
	import VueApexCharts from "vue-apexcharts";
	import {CrudAction} from "@/libs/core/crud/crud-action";
	import {createCrudQueryPayload, createGroupedQueryPayload} from "@/libs/core/crud/crud-query";
	import {
		ConvertFunctionEnum,
		ExchangeRateModel, GroupByDefinition,
		GroupByProjectionDefinition,
		ProjectionAggregationEnum,
		QueryOperator
	} from "@/libs/Api";
	import {Constants} from "@/libs/constants/constants";
	import moment from "moment";
	import {exchangeRatesStore} from "@/libs/exchange-rates/+state/store";
	import {CrudGetter} from "@/libs/core/crud/crud-getter";

	@Component({
		components: {VueApexCharts}
	})
	export default class ChartByTransaction extends Chart {

		loaded = false;
		chartSeries = [];
		chartOptions = {};

		@Prop() dateRange!: string;
		@Prop() fromDate!: string;
		@Prop() toDate!: string;
		@Prop() height!: number;

		@Watch("dateRange")
		dateRangeChanged(): void {
			this.loadData();
		}

		@Watch("fromDate")
		@Watch("toDate")
		dateChanged(): void {
			if (this.dateRange == "custom") {
				this.loadData();
			}
		}

		mounted(): void {
			console.log("height", this.height);
			this.loadData();
		}

		loadData(): void {
			this.loaded = false;
			exchangeRatesStore.dispatch(CrudAction.GetGrouped, createGroupedQueryPayload<ExchangeRateModel>([
				{ field: 'productId', op: QueryOperator.Eq, comparand: Constants.CltProductId },
				{ field: 'isPublic', op: QueryOperator.Eq, comparand: true },
				{ field: 'fromDate', op: QueryOperator.Gte, comparand: this.getRangeFromDate(this.dateRange, this.fromDate) },
				{ field: 'fromDate', op: QueryOperator.Lte, comparand: this.getRangeToDate(this.dateRange, this.toDate) },
			], [
				{
					field: "fromDate",
					convert: ConvertFunctionEnum.Year
				} as GroupByDefinition,
				{
					field: "fromDate",
					convert: ConvertFunctionEnum.Month
				} as GroupByDefinition
			], [
				{
					field: "Rate",
					aggregation: ProjectionAggregationEnum.Avg,
					outputField: "Rate"
				} as GroupByProjectionDefinition
			], "DialogExchangeRates"));
			this.subscribe(exchangeRatesStore, CrudAction.GetGrouped, "DialogExchangeRates").then(() => {
				this.make();
				this.loaded = true;
			});
		}

		make(): void {
			let data = exchangeRatesStore.useGetter(CrudGetter.GroupedData, "DialogExchangeRates") as any[];
			const minValue = data?.length > 0 ? data?.select(x => x.rate)?.min() : 0;
			const maxValue = data?.length > 0 ? data?.select(x => x.rate)?.max() : 0;
			const minDate = data?.length > 0 ? data.select(x => new Date(x.key.year, x.key.month - 1, 1).getTime())?.min() : new Date().getTime();
			const maxDate = data?.length > 0 ? data.select(x => new Date(x.key.year, x.key.month - 1, 1).getTime())?.max() : new Date().getTime();
			this.chartOptions = this.getChartOptions(moment(minDate).format("YYYY-MM-DDTHH:mm:ss"), moment(maxDate).format("YYYY-MM-DDTHH:mm:ss"), minValue, maxValue);
			this.chartSeries = [
				{
					name: "Vývoj kurzu",
					data: data.select(x => [ new Date(x.key.year, x.key.month - 1, 1).getTime(), x.rate ]).orderBy(x => x[0]).toArray()
				}
			];
		}

	}
